import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ChecklistTaskService } from '@app/shared/services/checklist/checklist-task.service';
import { Subscription } from 'rxjs';
import { SharedConfirmationDialogComponent } from '../../shared-confirmation-dialog/shared-confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import * as fileSaver from 'file-saver';
import { HttpClient } from '@angular/common/http';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'check-list-task-attachments',
  templateUrl: './check-list-task-attachments.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckListTaskAttachmentsComponent implements OnInit, OnDestroy {
  @Input() task_id;
  @Input() user;
  @Input() user_id;
  @Input() mode;

  attachedAdded = false;
  @Output() attachedAddedChange = new EventEmitter<boolean>();
  attachmentFiles = [];
  subscription: Subscription = new Subscription();
  getFileExtension(fileName: string) {
    if (fileName == undefined) {
      return 'doc';
    }
    let type = fileName.replace(/^.*\./, '') != fileName ? fileName.replace(/^.*\./, '') : '';
    if (type == '') {
      return 'doc';
    } else {
      return type.toLowerCase();
    }
  }
  constructor(
    private ChecklistTaskService: ChecklistTaskService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private http: HttpClient,
    private cd: ChangeDetectorRef
  ) {}
  ngOnInit(): void {
    if ((this.mode = 'edit')) {
      this.getChecklistDetails(this.task_id);
    }
    this.getAttachmentList();
  }
  getAttachmentList() {
    this.subscription.add(
      this.ChecklistTaskService.getAttachmentsListForTask(this.user.id, this.task_id).subscribe((res) => {
        this.attachmentFiles = res.files;
        this.cd.detectChanges();
        return this.attachmentFiles.length;
      })
    );
  }
  async getChecklistDetails(checklistId) {
    this.subscription.add(
      this.ChecklistTaskService.getChecklistDetails(checklistId).subscribe((res) => {
        if (res) {
          this.user_id = res.data[0].user_id;
        }
      })
    );
  }
  downloadAttachment(id, name) {
    this.subscription.add(
      this.ChecklistTaskService.downloadAttachment(this.user.id, id).subscribe((res) => {
        const file = res.files.data;
        this.downloadFileFromS3(file, name);
      })
    );
  }
  downloadFileFromS3(url: string, fileName: string): void {
    // Fetch the file from the S3 URL
    this.subscription.add(
      this.http.get(url, { responseType: 'blob' }).subscribe(
        (blob) => {
          // Create a new Blob object with the response data
          const downloadBlob = new Blob([blob], { type: blob.type });

          // Use FileSaver.js to save the file
          fileSaver.saveAs(downloadBlob, fileName);
        },
        (error) => {
          console.error('Error downloading file:', error);
        }
      )
    );
  }
  deleteAttachment(index, id, display_file_name) {
    const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: { title: 'Delete File', materialIcon: 'delete', text: `Are you sure you want to delete ${display_file_name}?`, proceedTitle: 'Delete' },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.subscription.add(
            this.ChecklistTaskService.deleteUploadedAttachment(this.user.id, id).subscribe(
              (res) => {
                this.attachmentFiles.splice(index, 1);
                this.toastr.success(`${display_file_name} deleted`);
                this.attachedAdded = false;
                this.attachedAddedChange.emit(this.attachedAdded);
                this.cd.detectChanges();
              },
              (error) => {
                this.toastr.error('Error deleting File');
              }
            )
          );
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
